<template>
  <div :class="customClasses"></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheTransition',
  computed: {
    ...mapGetters({
      transition: 'page/getTransition'
    }),
    customClasses () {
      return [
        'transition',
        { 'is-in': this.transition === 'in' },
        { 'is-out': this.transition === 'out' }
      ]
    }
  }
}
</script>

<style lang="scss">
.transition{
  @include add-transition(400ms);

  width: 100%;
  height: 100%;
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  z-index: 10000;
  transform-origin: center;
  pointer-events: none;
  // border-radius: 50%;

  &.is-in{
    opacity: 1;
    // width: 100%;
  }

  &.is-out{
    opacity: 0;
    // width: 0%;
  }
}
</style>
